export type PlantTab = 'machines' | 'sync';

export interface PlantTabHandle {
  readonly plantTab: PlantTab;
}

export const plantTab = (tab: PlantTab): PlantTabHandle => ({ plantTab: tab });

const isPlantTab = (value: unknown): value is PlantTab => value === 'machines' || value === 'sync';

export const plantTabOf = (handle: unknown): PlantTab | null => {
  if (typeof handle !== 'object' || handle === null) return null;
  const tab: unknown = (handle as { readonly plantTab?: unknown }).plantTab;
  return isPlantTab(tab) ? tab : null;
};
